import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateWorkflowPermissionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { usePermissionsContext } from '../../../PermissionsContext'
import { buildCreatePermissionInputFromRecord } from '../../../utils'
import { WorkflowPermissionRecord } from '../../../types'

export function useCustom(): CustomRowActionOptions<WorkflowPermissionRecord>[] {
  const { refetch } = usePermissionsContext()
  const [createPermission, { loading: creating }] =
    useCreateWorkflowPermissionMutation(DefaultMutationHookOptions)

  return [
    {
      text: 'Duplicate',
      permission: 'admin',
      hidden: ({ deleted }) => deleted,
      loading: creating,
      onClick: async (record) => {
        await createPermission({
          variables: {
            input: buildCreatePermissionInputFromRecord(record),
          },
        })
        await refetch()
        simpleCreateNotification('Permission')
      },
    },
  ]
}
